import { Component , Prop , Mixins, Watch } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import { CourseMultimediaObjectMixin } from '@/courses/mixins/course-multimedia-object.mixin';
import { COURSE_EVENTS } from '@/content/values/events';

@Component({name: 'ed-viewer-video-object-component'})
export default class EdViewerVideoObjectComponent extends Mixins(CourseMultimediaObjectMixin) {

  /* Props */
  @Prop({default: null}) readonly section: Section; 
  @Prop({default: null}) readonly sectionMaterial: any; 
  @Prop() isSolutionMaterial : boolean;
  isLoading = true;
  isSafari = false;

  /* Data */
  private videoElementType: string = 'multimediaVideo';

  /* Computed */
  get videoUrl(): string {
    if(this.sectionMaterial) return this.sectionMaterial.data.contentFileUrl || this.sectionMaterial.materialAssetInfo?.url;
    if(this.section.assetsInfo.length) return this.section.assetsInfo[0].url;
    return '';
  }

  get canShowSpinnerSafari() {
    return this.isLoading && this.isSafari;
  }

  /* Methods */
  onVideoReady() {
    this.isLoading = false;
  }

  preventManualPlay(event: Event) {
    if (this.isLoading) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  private findVideoElement(): HTMLVideoElement {
    return (this.$refs.multimediaVideo as HTMLVideoElement);
  }

  /* Hooks */
  mounted() {
    this.isSafari = this.detectSafari();
    this.setMediaElement(this.findVideoElement(), this.videoElementType);
    if(this.isPresentationModeTeacher && !this.isSolutionMaterial && this.isCurrentBoardUserTeacher) {
      this.setTeacherListenerEvents();
    }
    if(this.isPresentationModeStudent) {
      this.$edEventBus.$on(COURSE_EVENTS.UPDATE_MULTIMEDIA_VIDEO_STATE, this.updateMediaElementState);
      this.setStudentInitalState();
    }

    this.mediaElement.addEventListener('click', this.preventManualPlay)
  }

  beforeDestroy() {
    if(this.isPresentationModeStudent) {
      this.$edEventBus.$off(COURSE_EVENTS.UPDATE_MULTIMEDIA_VIDEO_STATE, this.updateMediaElementState);
      this.$EdModal.closeModal();
    }
  }

  detectSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');
  }
}